export function fullNameElseID (key, val) {
  if (val.osUserId && val.osUserId !== '') {
    if (val.userPreferredName && val.userPreferredName !== '') {
      return val.userPreferredName
    } else if (val.name && val.name !== '') {
      return val.name
    } else if (val.userName && val.userName !== '') {
      const username = jsUcfirst(val.userName.split(' ')[0])
      return username
    } else if (val.shortID) {
      return 'Guest ' + val.shortID
    } else {
      return 'Guest'
    }
  } else if (val.firstName && val.lastName) {
    return val.firstName + ' ' + val.lastName
  } else if (val.name) {
    return val.name
  } else if (val.orderInfoByText && val.orderInfoByText.name) {
    return val.orderInfoByText.name
  } else if (val.shortID) {
    return 'Guest ' + val.shortID
    // this is short key
    // return val.shortID
  } else {
    return 'Guest'
    // this is long key
    // return key
  }
}
function jsUcfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}



// WEBPACK FOOTER //
// ./src/utility/preferUserName.js